import useEffectOnce from "hooks/useEffectOnce";
import { createProgressBar, useProgressBar } from "v2/modules/progress-bar/progressBarState";

export const intakeProgressBar = createProgressBar(
  ["eligibility_check", "additional_information", "documents", "finish"],
  {
    eligibility_check: "left_menu.eligibility_check",
    additional_information: "left_menu.additional_information",
    documents: "left_menu.documents",
    finish: "left_menu.finish",
  },
);

export function useIntakeProgressBarSegment(step: string) {
  const { activateProgressBarSegment } = useProgressBar(intakeProgressBar);
  useEffectOnce(() => activateProgressBarSegment(step));
}
